import type { LookoRouteObject } from '../LookoRouteObject';
import { sellerMap } from '../managementMaps';

// 대시보드
const dashboardRoutes: LookoRouteObject[] = [
  {
    path: sellerMap['dashboard'].path,
    async lazy() {
      const { default: Page } = await import('@/app/dashboard/DashboardPage');
      return {
        Component: Page,
      };
    },
  },
];

export default dashboardRoutes;
